import React from "react";

import DriversApplicationTable from "./DriversPendingTable";

function DriversApplication() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card card-block card-stretch card-height">
            {" "}
            <div className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title mb-0">Drivers List</h4>
              </div>
              {/* {!check && (
                <Link to="add" className="float-right btn btn-sm btn-primary">
                  <i className="fa fa-plus-circle" /> Add Driver
                </Link>
              )} */}
            </div>
            <DriversApplicationTable />
            {/* <Table /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriversApplication;
